import { useSelector } from 'react-redux';

import { DOUBLE_DASH } from 'consts/placeholders';
import { formatDate } from 'modules/I18N';
import { TimelineItem } from 'lib/Timeline';
import { DetailedInventoryAsset } from 'components/common/types/DetailedInventoryAsset.types';
import { Store } from 'components/common/types/Store.types';

type Tag = DetailedInventoryAsset['tags'][number];

type TagInfoProps = {
  tagGroup: Tag[];
};

const TagInfo = ({ tagGroup }: TagInfoProps): React.ReactElement => {
  const { localeCode } = useSelector((state: Store) => state.publisher.configuration);

  return (
    <TimelineItem
      title={
        <div className="grid grid-cols-3 gap-x-4 items-center" data-test-id="tag-group">
          {tagGroup.map(({ tagUuid, tagName }) => (
            <p key={tagUuid} className="body-sm break-all">
              {tagName ?? DOUBLE_DASH}
            </p>
          ))}
        </div>
      }
    >
      <div className="grid grid-cols-3 gap-x-4">
        {tagGroup.map(({ tagUuid, startDate, endDate }) => (
          <p key={tagUuid} className="body-base text-neutral-950-opacity-60">{`${formatDate(
            startDate,
            localeCode,
          )}-${formatDate(endDate, localeCode)}`}</p>
        ))}
      </div>
    </TimelineItem>
  );
};

export default TagInfo;
